var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronUpGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 12.084a.831.831 0 01-.589-.244L9.99 9.086l-2.744 2.65a.833.833 0 01-1.158-1.2L9.42 7.318a.833.833 0 011.168.01l3.333 3.333a.832.832 0 01-.589 1.423z",
    fill: "#697484"
  })));
}

export default SvgChevronUpGray;